// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer___3P_OL","list":"list___1WLY0","icp":"icp___3_d6k","lang":"lang___36Bag"};